import { Directive, Input, OnInit } from '@angular/core';

import styles from './VbBtn.Directive.module.less';

@Directive({
	selector: '[vbBtnPrimary]',
	host: {
		'[class]': 'hostClass'
	},
	standalone: false
})
export class VbBtnPrimaryDirective implements OnInit {
	@Input() public ignoreVbBtnPrimary: boolean;

	public hostClass;

	public ngOnInit() {
		if (this.ignoreVbBtnPrimary) {
			return;
		}

		this.hostClass = `btn ${styles.vbBtn} ${styles.btnPrimary}`;
	}

}
